var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.298 13.852c0-.787-.063-1.58-.198-2.354H12.288v4.462h6.192a5.367 5.367 0 01-2.292 3.52v2.895h3.694c2.17-2.017 3.416-4.998 3.416-8.523z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.288 25.172c3.092 0 5.699-1.026 7.598-2.797l-3.694-2.895c-1.027.707-2.354 1.107-3.9 1.107-2.99 0-5.526-2.04-6.435-4.78H2.045v2.984c1.946 3.912 5.91 6.381 10.243 6.381z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.852 15.806a7.01 7.01 0 010-4.436V8.386H2.045a11.708 11.708 0 000 10.405l3.807-2.985z",
    fill: "#FBBC04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.288 6.585a6.193 6.193 0 014.397 1.737l3.273-3.308A10.952 10.952 0 0012.288 2C7.954 2 3.991 4.469 2.045 8.386l3.807 2.984c.906-2.746 3.446-4.785 6.436-4.785z",
    fill: "#EA4335"
  })));
}

export default SvgGoogle;